import { gsap } from "gsap";

export default class LocationGridHandler {
	init() {
		this.normalizeGridHeights();

		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this.normalizeGridHeights();
			}, 100);
		});
	}

	normalizeGridHeights() {
		const locationGrid = document.querySelector('[data-location-grid]');
		if (!locationGrid) return;

		const accordions = locationGrid.querySelectorAll('[data-accordion="container"]');
		if (accordions.length === 0) return;

		// Reset heights
		accordions.forEach(accordion => {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			trigger.style.minHeight = '';
			accordion.style.height = '';
		});
		void locationGrid.offsetHeight;

		// Find the tallest trigger height
		let maxHeight = 0;
		accordions.forEach(accordion => {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const height = trigger.offsetHeight;
			if (height > maxHeight) {
				maxHeight = height;
			}
		});

		// Apply the max height to all triggers and update accordion container heights
		accordions.forEach(accordion => {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			const isActive = accordion.classList.contains('is-active');

			// Set min height on trigger
			trigger.style.minHeight = `${maxHeight}px`;

			// Update accordion container height
			const targetHeight = isActive
				? maxHeight + content.scrollHeight
				: maxHeight;

			gsap.set(accordion, { height: targetHeight });
		});
	}
}
